export const RECOMMENDATIONS_AND_MEDICINES_SET_MANAGEMENT_MODE = 'RECOMMENDATIONS_AND_MEDICINES_SET_MANAGEMENT_MODE'
